import type { ExternalLayer } from 'hooks/externalLayer/types';
import { formatDateTime } from 'components/IAP/Resources/utils/dateUtils';
import { LayerFeaturesContent } from './LayerFeaturesContent';
import { LayerMetadata } from './LayerDataRows';
import { Layer } from './Layer';
import { useUscgMapContext } from './UscgMapContext';

export function ExternalLayerItem({
  layer,
  onDelete,
  onOpenInNewClick,
  onZoomToLayer,
  onZoomToGraphic,
}: {
  layer: ExternalLayer;
  onDelete: () => void;
  onOpenInNewClick?: () => void;
  onZoomToLayer?: () => void;
  onZoomToGraphic: (graphic: __esri.Graphic) => void;
}) {
  const eventKey = `external-${layer.id}`;
  const { isExternalLayerLoadError } = useUscgMapContext();
  const hasLoadError = isExternalLayerLoadError(layer.id);

  return (
    <Layer.Item
      eventKey={eventKey}
      cardClassName={
        hasLoadError ? 'bg-danger-subtle border-danger' : undefined
      }
      header={
        <Layer.Header
          title={layer.name}
          layerId={layer.id}
          layerType="external"
          error={
            hasLoadError
              ? `Failed to load layer from ArcGIS. Please check your permissions. (itemId: ${layer.arcgisItemId})`
              : undefined
          }
          onOpenInNew={onOpenInNewClick}
          onZoomToLayer={onZoomToLayer}
          onDelete={onDelete}
        />
      }
    >
      <Layer.Content>
        <LayerMetadata
          lastUpdated={formatDateTime(layer.updatedAt)}
          aorIds={layer.aorIds}
          incident={layer.incidentId}
          sources="ArcGIS Online"
        />
        <LayerFeaturesContent
          layer={layer}
          layerType="external"
          onZoomToExternalGraphic={onZoomToGraphic}
        />
      </Layer.Content>
    </Layer.Item>
  );
}
